import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import SignIn from "./components/Signin";
import Dashboard from "./components/Dashboard";
import Home from './components/Home';
import { UserProvider } from "./components/UserContext";
import ProtectedRoute from './components/ProtectedRoute';
import Billing from './components/Billing';
import AddressValidator from './components/AddressValidator';
import Recent24HourNews from './components/Recent24HourNews';
import Screeners from './components/Screeners';
import OHLCV from './components/OHLCV';
import EconomicEvents from './components/EconomicEvents';
import Cryptography from './components/Cryptography';
import Pricing from './components/Pricing';
import PaymentForm from './components/PaymentForm';
import PaymentDetails from './components/PaymentDetails';


function App() {
  const [filters, setFilters] = useState({});
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    const token = localStorage.getItem('token');

    if (storedUser && token) {
      try {
        setUser(JSON.parse(storedUser));
      } catch (error) {
        console.error('Error parsing stored user:', error);
        localStorage.removeItem('user');
        localStorage.removeItem('token');
      }
    }
    setLoading(false);
  }, []);

  const handleSignIn = (userData) => {
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    localStorage.removeItem('authToken');
    setUser(null);
  };

  const handleSearch = (filterData) => {
    setFilters(filterData);
  };

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        background: '#000000',
        color: '#00ff41',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'monospace',
        fontSize: '1.2rem'
      }}>
        <span>root@quantdelta~# initializing...</span>
      </div>
    );
  }

  return (
    <Router>
      <UserProvider>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route
              path="/signin"
              element={
                user ? <Navigate to="/dashboard" replace /> : <SignIn onSignIn={handleSignIn} />
              }
            />
            <Route
              path="/dashboard"
              element={
                user ? <Dashboard user={user} onLogout={handleLogout} /> : <Navigate to="/signin" replace />
              }
            />
            <Route path="/billing" element={<Billing />} />
            <Route
              path="/address-validator"
              element={
                <ProtectedRoute user={user}>
                  <AddressValidator />
                </ProtectedRoute>
              }
            />
            <Route
              path="/recent-news"
              element={
                <ProtectedRoute user={user}>
                  <Recent24HourNews />
                </ProtectedRoute>
              }
            />
            <Route
              path="/screeners"
              element={
                <ProtectedRoute user={user}>
                  <Screeners />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ohlcv"
              element={
                <ProtectedRoute user={user}>
                  <OHLCV />
                </ProtectedRoute>
              }
            />
            <Route
              path="/economic-events"
              element={
                <ProtectedRoute user={user}>
                  <EconomicEvents />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cryptography"
              element={
                <ProtectedRoute user={user}>
                  <Cryptography />
                </ProtectedRoute>
              }
            />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/payment-form" element={<PaymentForm />} />
            <Route path="/payment-details" element={<PaymentDetails />} />
          </Routes>
        </Layout>
      </UserProvider>
    </Router>
  );
}

export default App;
